import React from 'react';
import PropTypes from 'prop-types';
import ToastItems from './toastItems';
import { ToastWrapper } from './styles';

const toastTypes = {
  'SIMPLE': 'simple',
  'STICKY': 'sticky',
};

const Toast = ({ toasts, afterAction }) => {
  const simpleToasts = toasts.filter((toast) => (toast.type === undefined || toast.type === toastTypes.SIMPLE));
  const stickyToasts = toasts.filter((toast) => toast.type === toastTypes.STICKY);
  return (
    <>
      <ToastWrapper data-testid="simpleToast" type={toastTypes.SIMPLE}>
        <ToastItems toasts={simpleToasts} action={afterAction} type={toastTypes.SIMPLE} />
      </ToastWrapper>
      <ToastWrapper data-testid="stickyToast" type={toastTypes.STICKY}>
        <ToastItems toasts={stickyToasts} action={afterAction} type={toastTypes.STICKY} />
      </ToastWrapper>
    </>
  );
};

Toast.propTypes = {
  toasts: PropTypes.array,
  afterAction: PropTypes.func,
};

export default Toast;
